


import { Component, Vue, Emit } from 'vue-property-decorator';
import { RouteNames } from '@/utils/router/router.models';

@Component({})
export default class ChannelSelection extends Vue {
  private RouteNames: typeof RouteNames = RouteNames;

  @Emit('navigate-back')
  private navigateBack() {
    return;
  }
}
